module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"shippingMethod":"Shipping method"},"de":{"shippingMethod":"Versandart"}}')
  delete Component.options._Ctor
}
